module.exports = __webpack_public_path__ + "static/media/admin.b2d92873.png";